import selectTimeIncrementOption from '../data/mutators/selectTimeIncrementOption';
import HourIncrement from 'owa-service/lib/contract/HourIncrement';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { observer } from 'mobx-react';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import getTimeIncrement from '../selectors/getTimeIncrement';

/**
 * The TimeIncrement parameter specifies the scale that the Outlook on the web calendar uses to show time.
 * Valid values are: FifteenMinutes, ThirtyMinutes (default value)
 */
export default observer(function TimeIncrement() {
    const onTimeIncrementChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectTimeIncrementOption(parseInt(option.key));
    };
    const timeIncrementOptions = [
        {
            key: HourIncrement.FifteenMinutes.toString(),
            text: strings.options_timeincrement_15_minutes,
        },
        {
            key: HourIncrement.ThirtyMinutes.toString(),
            text: strings.options_timeincrement_30_minutes,
        },
    ];

    return (
        <ChoiceGroup
            selectedKey={`${getTimeIncrement()}`}
            label={strings.options_appearance_timeIncrementLabel}
            options={timeIncrementOptions}
            onChange={onTimeIncrementChange}
        />
    );
});
